import axiosClient from "utils/axios";
import { ApiList, ApiOptionList, ApiResponse } from "types/api.types";
import type { Department } from "../types/department.types";

export const getDepartments = async ({
  page = 1,
  limit = 20,
  search,
}: {
  page?: number;
  limit?: number;
  search?: string;
} = {}) => {
  const response = await axiosClient.get<ApiResponse<ApiList<Department[]>>>(
    "/departments",
    { params: { page, limit, search: search?.trim() || undefined } },
  );
  return response.data;
};

export const getDepartmentOptions = async ({
  query,
  page = 1,
  limit = 50,
}: {
  query?: string;
  page?: number;
  limit?: number;
}) => {
  const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
    "/departments/options",
    { params: { query: query?.trim() || undefined, page, limit } },
  );
  return response.data;
};

export const createDepartment = async (payload: { name: string }) => {
  const response = await axiosClient.post<ApiResponse<Department>>(
    "/departments",
    payload,
  );
  return response.data;
};

export const updateDepartment = async (
  id: number,
  payload: { name: string },
) => {
  const response = await axiosClient.put<ApiResponse<Department>>(
    `/departments/${id}`,
    payload,
  );
  return response.data;
};

export const deleteDepartment = async (id: number) => {
  const response = await axiosClient.delete<ApiResponse<unknown>>(
    `/departments/${id}`,
  );
  return response.data;
};
